import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environments';
import { endpoints } from '../endpoints';
import { IContact } from '../models/contact';
import { ErrorService } from '../helpers/errorService';
import { EEopTemplates } from '../models/eop_types.enum';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  constructor(
    private http: HttpClient,
    private errorService: ErrorService
  ) { }

  getContacts(buildingId: string): Observable<{has_error: boolean, message: string, data: IContact[]}> {
    const url = environment.apiBaseUrl + endpoints.contacts.replace(':buildingId', buildingId);
    return this.http.get<{has_error: boolean, message: string, data: IContact[]}>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }

  // get contacts by buildingId
  getBuildingPlanningTeam(buildingId: string, eopTemplateId: EEopTemplates, teamTypeId?: string): Observable<{has_error: boolean, message: string, data: any[]}> {
    const url = environment.apiBaseUrl + endpoints.getBuildingDepartmentContacts.replace(':buildingId', buildingId).replace(':eopTemplateId', eopTemplateId.toString());
    let params = new HttpParams();
    if (teamTypeId) {
      params = params.set('team_type_id', teamTypeId);
    }
    return this.http.get<{has_error: boolean, message: string, data: any[]}>(url, { params }).pipe(
      catchError(this.errorService.handleError)
    );
  }

  // get contacts by buildingId and departmentId
  getDepartmentContacts(buildingId: string, departmentId: string): Observable<{has_error: boolean, message: string, data: IContact[]}> {
    const url = environment.apiBaseUrl + endpoints.getDepartmentContacts.replace(':buildingId', buildingId).replace(':departmentId', departmentId);
    return this.http.get<{has_error: boolean, message: string, data: IContact[]}>(url).pipe(
      catchError(this.errorService.handleError)
    );
  };

  saveDepartmentContacts(buildingId: string, data: {collaborative_department: number, contact_id: number}[]): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.saveDepartmentContacts.replace(':buildingId', buildingId);
    return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
      catchError(this.errorService.handleError)
    );
  }  

  removeDepartmentContacts(buildingId: string, departmentId: string): Observable<{has_error: boolean, message: string, data: any}> {
    const url = environment.apiBaseUrl + endpoints.removeDepartmentContacts.replace(':buildingId', buildingId).replace(':departmentId', departmentId);
    return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
      catchError(this.errorService.handleError)
    );
  }


}